<!--  -->
<template>
    <div>
        <div class="guide-block"></div>
        <van-cell-group>
            <van-cell center title="常见问题">
                <template #title>
                    <div class="guide-item flex align-center">
                        <img src="../../assets/images/operationGuide/question.png" alt="" />
                        <p>常见问题</p>
                    </div>
                </template>
            </van-cell>
            <van-cell v-for="item in questionList" :key="item.id" @click="skipDetail(item)" is-link>
                <template #title>
                    <div class="guide-item flex align-center">
                        <div></div>
                        <p>{{ item.title }}</p>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
    </div>
</template>

<script>
import { zzconfig } from "@/config/zzconfig";
export default {
    name: "Question",
    data() {
        return {
            questionList: [
                {
                    id: 0,
                    title: "车辆已经出场，计时收费仍然在累计怎么办？",
                    content: `
                    <p>
                  <p>【方式一】：</p>
                  请在【客服帮助】页面，点击【订单申诉】，填写订单问题，工作人员会在三个工作日内处理您的问题。
  <p>【方式二】：  </p>拨打客服电话：「${zzconfig.PHONE}」并告知您的车牌号，后台经核实后将收取实际停车
费用。如已付费，后台经核实后将收取实际停车费用，超出费用将在核实后进行原支付路径退款。

                    </、p>`,
                },

                {
                    id: 1,

                    title: "出现多次支付失败的情况如何解决？",
                    content: `
                    <p>
                  微信支付如因网络延迟，客户手机界面未能及时出现支付成功的提示，从而出现用户多次支付的情况，系统后台会在三个工作日内会按原路自动退回客户账户中（银行卡支付即退回银行卡，微信零钱支付就退回零钱）；</p><br/>
 <p>如果在三个工作日内未收到退款，请在【客服帮助】页面，点击【订单申诉】，填写订单问题，工作人员会在三个工作日内处理您的问题。</p><br/>
 <p>或者请拨打客服电话：「${zzconfig.PHONE}」，告知客服您当时的停车订单编号（“泉港智慧停车”公众号——【个人中心】模块——选择【我的账单】），我们将第一时间为您退款。

                    </p>`,
                },
                {
                    id: 2,

                    title: "当我在停车位上发生车辆受损/财物丢失时，如何申请赔偿？",
                    content: `
                    <p>
                 当您在“泉港智慧停车”公共管理的停车泊位停放，我们只收取您的「公共资源管理服务费」，如您在停车期间发生机动车受损或者车内财物丢失情况，机动车所有人可以向投保的保险公司要求赔偿或者报警，相应的路边停车管理单位将协助您提供必要的帮助。
                    </p>`,
                },
            ],
        };
    },

    components: {},

    computed: {},

    mounted() {},

    methods: {
        //跳转到指南详情
        skipDetail(item) {
            this.$router.push({
                name: "operationGuideDetail",
                params: item,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.guide-block {
    height: 16px;
}
.guide-item {
    div {
        width: 32px;
        height: 32px;
    }

    img {
        width: 32px;
        height: 32px;
    }
    p {
        font-size: 28px;
        color: #333333;
        margin-left: 17px;
    }
}
</style>
